import * as React from 'react'
import { ImageUrl } from '@utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './packshot.module.scss'
import * as heroSt from './heroshot.module.scss'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import * as cn from 'classnames'
import { ResponsiveImage } from '../images/responsiveImage'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import { ConditionalWrapper } from '../../utils/conditionalWrapper'
import { HEROSHOT_DESKTOP_WIDTH, HEROSHOT_MOBILE_WIDTH, HEROSHOT_TABLET_WIDTH } from './heroConstants'
import { SrcSize } from '../../utils/imageUtils'

export interface IPackshotProps extends AtfTreatmentProps {
  packshot?: string
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string
  pageTitleId: string
  isRetail: boolean
  isTV?: boolean
  useNodeDeeplinking: boolean
}

export const Packshot = ({ packshot, playbackData, sessionId, pageTitleId, isRetail, isTV, useNodeDeeplinking, atfTreatment }: IPackshotProps) => {
  if (!packshot) {
    return null
  }
  const background = new ImageUrl(packshot)
    .scaleWidth(300)
    .setBlur(80)
    .getImageUrl()

  const backgroundPackshotStyle = {
    backgroundImage: `url(${background})`
  }

  const blurredBackgroundProps = {
    alt: '', // Decorative image so no alt
    src: new ImageUrl(packshot).setBlur(90).getImageUrl(),
    baseValue: HEROSHOT_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': HEROSHOT_MOBILE_WIDTH },
      { 'max-tablet': HEROSHOT_TABLET_WIDTH },
      {'min-tablet': HEROSHOT_DESKTOP_WIDTH}
    ] as SrcSize[]
  }

  const packshotImgProps = {
    alt: '', // Decorative image so no alt
    src: packshot,
    baseValue: isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? 600 : 300,
  }

  const packshotClassNames = cn(
    isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.packshotRedesign : st.packshot,
    isTV ? (isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.seasonPackshotRedesign : st.seasonPackshot) : undefined,
    'dv-fallback-packshot-image'
  )

  return (
    <React.Fragment>
      <div className={cn(heroSt.avHeroBackground, isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? cn(heroSt.avHeroBackgroundRedesign, st.packshotWrapper) : st.packshotBackground)}
           data-automation-id="hero-background" style={!isTreatment(atfTreatment,'T1', 'T2', 'T3') ? backgroundPackshotStyle : undefined}>

        <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={cn(heroSt.imageFadeWrapper, heroSt.imageFadeWrapperRedesign)}>{children}</div>}>
          {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <div className={heroSt.avHeroBackgroundFadeLeft}/>}
          {isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <ResponsiveImage className={heroSt.heroshot} {...blurredBackgroundProps} skipStripTags={true}/>}
          <div className={heroSt.avHeroBackgroundFadeBottom}/>
        </ConditionalWrapper>

      </div>
      <div className={packshotClassNames}>
        {isTreatment(atfTreatment, 'T1', 'T2', 'T3') ?
          <span className={st.imageWrapper}>
            <ResponsiveImage {...packshotImgProps} />
            {isTreatment(atfTreatment,'T3') && isRetail && playbackData &&
            <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} isPackshot useNodeDeeplinking={useNodeDeeplinking} atfTreatment={atfTreatment}/>}
          </span>
        :
          <>
            <ResponsiveImage {...packshotImgProps} />
            {isRetail && (
              <div className="playback-large-circle-wrapper">
                <div id="dv-play-box-circle">
                  {playbackData && (
                    <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} isPackshot useNodeDeeplinking={useNodeDeeplinking}/>
                  )}
                </div>
              </div>
            )}
          </>
        }
      </div>
    </React.Fragment>
  )
}
